<ng-container *transloco="let t; read: 'event-split-dialog'">
  <p>{{ t('instructions') }}</p>

  <form *ngIf="!loading" [formGroup]="form">
    <label class="event-split-dialog__field">
      <span class="event-split-dialog__label">{{ t('label') }}</span>
      <input
        formControlName="splitTime"
        pInputText
        type="datetime-local"
        [max]="maxTime"
        [min]="minTime"
        [step]="900"
      />
      <app-form-field-help [control]="splitTime">
        <ng-container form-field-help-errors>
          <div *ngIf="splitTime?.errors?.stepSizeSeconds">{{ t('splitTimeIntervalError') }}</div>
          <div *ngIf="splitTime?.errors && !splitTime?.errors?.stepSizeSeconds">{{ t('splitTimeError') }}</div>
        </ng-container>
      </app-form-field-help>
    </label>
  </form>

  <button mat-button type="button" (click)="cancel()">{{ t('cancelButton') }}</button>
  <button color="primary" mat-raised-button type="button" [disabled]="form.invalid" (click)="confirm()">
    {{ t('okButton') }}
  </button>
</ng-container>
